import innerHTML from 'utils/DOM/innerHTML'

function setCounter(time, callback, element, interval) {
  let timeleft = time
  const intervalRef = setInterval(function() {
    if (timeleft <= 0) {
      callback()
      clearInterval(intervalRef)
    } else {
      innerHTML(element, timeleft)
    }
    timeleft -= 1
  }, interval)

  return intervalRef
}

export default setCounter
